import React from "react";

import { getAccordionEventKey } from "./utils";
import { useMe } from "../../../../hooks/queries";
import { AccountType } from "../../../../models/AccountData";
import { LocationData } from "../../../../models/LocationData";
import { EditProfileButton } from "../../EditProfileButton";
import { EditProfileFormSectionKeys } from "../../EditProfileForm/const";

interface IEditPickupFieldButtonProps {
  pickupFieldKey: string;
  onOpenModal: (
    accordionEventKey?: EditProfileFormSectionKeys | null | undefined
  ) => void;
  locationData: LocationData;
}

export const EditPickupFieldButton = (props: IEditPickupFieldButtonProps) => {
  const { pickupFieldKey, onOpenModal, locationData } = props;

  const { data: me } = useMe();
  const canEditProfile =
    !locationData.has_lodging &&
    (me?.type === AccountType.ADMIN || me?.type === AccountType.LOC_ADMIN);

  const accordionEventKey = getAccordionEventKey(pickupFieldKey);

  // If accordionEventKey is not defined, this means this pickup field's section has not been implemented yet
  // If the user cannot edit the profile, or there is no accordionEventKey, return nothing
  if (!accordionEventKey || !canEditProfile) {
    return null;
  }

  return (
    <EditProfileButton
      accordionEventKey={accordionEventKey}
      onOpenModal={onOpenModal}
      locationData={locationData}
    />
  );
};
